import { Controller } from "@hotwired/stimulus";

export class DropdownController extends Controller {
  static targets = ["panel", "button"];
  connect() {
    this.open = false;
  }

  toggle(e) {
    e?.stopPropagation();
    // En desktop confiamos en hover; el toggle es principalmente para móvil.
    if (window.matchMedia("(min-width: 768px)").matches) return;
    this.setOpen(!this.open);
  }

  setOpen(v) {
    this.open = v;
    this.buttonTarget.setAttribute("aria-expanded", String(v));
    this.element.setAttribute("aria-expanded", String(v));
    // En móvil mostramos/ocultamos (en desktop ya se maneja con :hover)
    if (!window.matchMedia("(min-width: 768px)").matches) {
      this.panelTarget.classList.toggle("hidden", !v);
    }
    // rota caret
    const caret = this.buttonTarget.querySelector("svg");
    if (caret) caret.style.transform = v ? "rotate(180deg)" : "rotate(0deg)";
  }

  onDocumentClick(e) {
    if (!this.open) return;
    if (!this.element.contains(e.target)) this.setOpen(false);
  }

  onKeydown(e) {
    if (!this.open) return;
    if (e.key === "Escape") {
      this.setOpen(false);
      this.buttonTarget.focus();
    }
  }
}
